import { ReactNode } from 'react';
import { Label } from 'components/elements/Label';
import { InfoModal } from 'components/widgets/InfoModal';

type Props = {
  label: string;
  children: ReactNode;
  hideDivider?: boolean;
};

const DetailRow = ({ label, children, hideDivider }: Props) => {
  return (
    <InfoModal.Row hideDivider={hideDivider}>
      <Label>{label}</Label>
      <InfoModal.RowDetails>{children}</InfoModal.RowDetails>
    </InfoModal.Row>
  );
};

export default DetailRow;
